import React from "react";
import { getFullName } from "../../careprovider/visits/utils";
import { RoleToLinkMapper } from "../../utils/UrlUtils";
import { useGetRole } from "../../generic/hooks/useGetRole";
import { useNavigate } from "react-router";
import { getUserAge } from "../../../utils/userdatautils";
import { Tag } from "antd";
import { getDateString } from "../../../utils/dateutils";

const AssignedPatient = ({ patient }) => {
  const role = useGetRole();
  const navigate = useNavigate();
  const patientAge = patient?.birthDate && getUserAge(patient?.birthDate);

  const handleNavigation = () => {
    navigate(
      `${RoleToLinkMapper(role)}patient-profile?identifier=${
        patient?.userIdentifier
      }`,
    );
  };
  return (
    <>
      <div className="patient-details-card">
        <div className="patient-details-card-header">
          <span
            className="patient-details-card-primary-title cursor-pointer"
            onClick={handleNavigation}
          >
            {getFullName(patient?.givenName, patient?.familyName)}
          </span>
          <span>(#{patient?.medicalRecordNumber})</span>
        </div>
        {patient?.lastTaskCreatedTimestamp && (
          <div>
            Date of Last Service:{" "}
            <span className="patient-details-card-primary-title">
              {getDateString(patient?.lastTaskCreatedTimestamp)}
            </span>
          </div>
        )}

        <div className="patient-details-card-header">
          <span>
            {patient?.gender &&
              `${patient?.gender?.charAt(0)}${patient?.gender
                ?.slice(1)
                .toLowerCase()},`}
            {patientAge && !isNaN(patientAge) && ` Age ${patientAge}`}
          </span>
        </div>
        <div>
          <Tag>{patient?.patientType.toUpperCase()}</Tag>
        </div>
      </div>
    </>
  );
};

export default AssignedPatient;
